import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { Icon, Header } from 'semantic-ui-react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { categoryItemsHavePhoto } from './ServicesListCategory.utils';
import MarkdownContent from '../../../../../../components/MarkdownContent';
import { classNames } from '../../../../../../utils/classname';
import SlideReveal from '../../../../../animations/components/Reveal/variants/SlideReveal';
import { DIRECTION_UP } from '../../../../../animations/components/Reveal/variants/SlideReveal/SlideReveal.constants';
import Accordion from '../../../../../foundation/components/Accordion';
import WebsiteComponentInteraction from '../../../../../interactions/components/WebsiteComponentInteraction';
import { INTERACTION_DISPLAY_TYPE_ICON } from '../../../../../interactions/constants';
import { splitInteractionsIntoClickthroughAndLink } from '../../../../../interactions/utils';
import { MenuCatalogCategoryPropType, MenuCatalogItemPropType, MenuCatalogModifierSetPropType, MenuCatalogModifierPropType } from '../../../../types/menu-catalog';
import { FIRST_PRICE_DISPLAY_TYPE } from '../../ServicesList.constants';
import { PriceDisplayTypePropTypes } from '../../types/price-display';
import ServicesListItem from '../ServicesListItem';
import './ServicesListCategory.css';
var defaultProps = {
  modifierSets: [],
  modifiers: [],
  priceDisplayType: FIRST_PRICE_DISPLAY_TYPE,
  displayZeroCostItemPrices: false,
  precision: 2,
  displayToggle: true,
  animated: false
};
export default function ServicesListCategory(_ref) {
  var category = _ref.category,
    items = _ref.items,
    modifierSets = _ref.modifierSets,
    modifiers = _ref.modifiers,
    active = _ref.active,
    onClick = _ref.onClick,
    index = _ref.index,
    priceDisplayType = _ref.priceDisplayType,
    displayZeroCostItemPrices = _ref.displayZeroCostItemPrices,
    precision = _ref.precision,
    displayToggle = _ref.displayToggle,
    animated = _ref.animated;
  function handleClick(e, data) {
    var isAnchor = 'href' in e.target.attributes;
    var isLink = 'to' in e.target.attributes;
    if (isAnchor || isLink) {
      e.stopPropagation();
    } else {
      onClick(e, data);
    }
  }
  var categoryName = category.name,
    categoryDescription = category.description,
    _category$interaction = category.interactions,
    interactions = _category$interaction === void 0 ? [] : _category$interaction;
  var displayImages = categoryItemsHavePhoto(items);
  var headerContent = categoryName;
  var _splitInteractionsInt = splitInteractionsIntoClickthroughAndLink(interactions),
    _splitInteractionsInt2 = _slicedToArray(_splitInteractionsInt, 2),
    clickThroughInteractions = _splitInteractionsInt2[0],
    linkInteractions = _splitInteractionsInt2[1];
  var finalClassName = classNames({
    'services-list-category': true,
    'cursor-default': !displayToggle
  });
  if (!_isEmpty(clickThroughInteractions)) {
    headerContent = /*#__PURE__*/React.createElement(WebsiteComponentInteraction, {
      interaction: _objectSpread(_objectSpread({}, clickThroughInteractions[0]), {}, {
        displayType: INTERACTION_DISPLAY_TYPE_ICON
      }),
      content: categoryName
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion.Title, {
    active: active,
    onClick: handleClick,
    index: index,
    className: finalClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: "services-list-header-wrapper"
  }, /*#__PURE__*/React.createElement(SlideReveal, {
    fade: true,
    disableAnimation: !animated,
    direction: DIRECTION_UP,
    triggerOnce: true
  }, /*#__PURE__*/React.createElement(Header, {
    as: "h3"
  }, headerContent), !_isEmpty(categoryDescription) && /*#__PURE__*/React.createElement(MarkdownContent, {
    className: "sub header"
  }, categoryDescription), !_isEmpty(linkInteractions) && /*#__PURE__*/React.createElement("div", {
    className: "sub header interactions"
  }, linkInteractions.map(function (interaction) {
    return /*#__PURE__*/React.createElement(WebsiteComponentInteraction, {
      interaction: interaction
    });
  }))), displayToggle && /*#__PURE__*/React.createElement(SlideReveal, {
    fade: true,
    disableAnimation: !animated,
    direction: DIRECTION_UP,
    triggerOnce: true,
    className: "icon-container",
    noContainer: true
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "toggle-icon",
    name: active ? 'minus square outline' : 'plus square outline'
  })))), /*#__PURE__*/React.createElement(Accordion.Content, {
    active: active
  }, items.map(function (item, itemIndex) {
    return /*#__PURE__*/React.createElement(ServicesListItem, {
      item: item,
      modifierSets: modifierSets,
      modifiers: modifiers,
      key: _get(item, '_id', itemIndex),
      priceDisplayType: priceDisplayType,
      displayZeroCostItemPrices: displayZeroCostItemPrices,
      precision: precision,
      displayImage: displayImages
    });
  })));
}
ServicesListCategory.defaultProps = defaultProps;